
import { Options, Vue } from "vue-class-component";
import { MutationTypes } from "../store/mutation-types";
import { useStore } from "../store";

@Options({
  props: {},
  methods: {
    setLanguage(language: string) {
      this.store.commit(MutationTypes.SET_LANGUAGE, language);
    },
  },
})
export default class Language extends Vue {
  store = useStore();
}
